import { DatePipe, DecimalPipe } from '@angular/common';
import { BytesPipe } from 'app/shared/pipe/bytes.pipe';
import { TypeLienUsagePipe } from 'app/shared/pipe/type-lien-usage.pipe';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "../pipe/bytes.pipe";
import * as i3 from "../pipe/type-lien-usage.pipe";
/**
 * Colonne d'un tableau
 */
export class Column {
    constructor(id, // Identifiant de la colonne (pour Angular Material)
    nom, type, metatype, property, // Propriété sur l'objet (vide dans le cas d'un paramètre)
    selected, editable, showOnlyIfShowAll, showOnlyIfNotShowAll, paramGroupName, // Nom du groupe de paramètre
    // depuis DéfinitionParametre
    codeBim, readonly, parametreListeChoix, parametreNombre, parametreTypeOuvrage) {
        this.id = id;
        this.nom = nom;
        this.type = type;
        this.metatype = metatype;
        this.property = property;
        this.selected = selected;
        this.editable = editable;
        this.showOnlyIfShowAll = showOnlyIfShowAll;
        this.showOnlyIfNotShowAll = showOnlyIfNotShowAll;
        this.paramGroupName = paramGroupName;
        this.codeBim = codeBim;
        this.readonly = readonly;
        this.parametreListeChoix = parametreListeChoix;
        this.parametreNombre = parametreNombre;
        this.parametreTypeOuvrage = parametreTypeOuvrage;
    }
}
Column.QUALIFICATION_COLUMN_SUFFIX = '_qualif';
/**
 * Préférence utilisateur sur l'affichage d'une colonne
 */
export class ColumnSetting {
    constructor(id, // Id de la colonne (= code bim dans le cas des paramètres)
    selected) {
        this.id = id;
        this.selected = selected;
    }
}
export class ElementFieldEdition {
    constructor(id, property, // dans le cas d'un champ simple
    codeBim, // dans le cas d'un paramètre
    value) {
        this.id = id;
        this.property = property;
        this.codeBim = codeBim;
        this.value = value;
    }
}
export class TableService {
    constructor(numberPipe, datePipe, byteFormatPipe, typeLienUsagePipe) {
        this.numberPipe = numberPipe;
        this.datePipe = datePipe;
        this.byteFormatPipe = byteFormatPipe;
        this.typeLienUsagePipe = typeLienUsagePipe;
    }
    /**
     * Renvoie la valeur d'un champ (dans son type d'origine)
     */
    getFieldValue(element, column) {
        if (column.property) {
            // case property
            return column.property.split('.').reduce((a, b) => a == null ? '' : a[b], element);
        }
        else {
            // case parameter
            return element.parametres[column.codeBim];
        }
    }
    /**
     * Renseigne la valeur d'un champ dans un élément.
     */
    setFieldValue(element, column, value) {
        let valueToSet = value;
        if (valueToSet == '' && (column.type == 'LISTE_CHOIX' || column.type == 'ETIQUETTE_DPE')) {
            // On remplace chaîne vide par null pour les liste de choix et les énums
            valueToSet = null;
        }
        if (column.property) {
            // case property
            if (column.property.split('.').length == 1) {
                element[column.property] = valueToSet;
            }
            else {
                const split = column.property.split('.');
                const containerObjects = split.slice(0, split.length - 1);
                const valueContainer = split[split.length - 1];
                const containerObject = containerObjects.reduce((a, b) => a == null ? '' : a[b], element);
                containerObject[valueContainer] = valueToSet;
            }
        }
        else {
            // case parameter
            if (!element.parametres) {
                element.parametres = {};
            }
            element.parametres[column.codeBim] = valueToSet;
        }
    }
    /**
     * Renvoie la valeur textuelle d'un champ (pour l'affichage)
     */
    getFieldValueAsString(element, column) {
        const value = this.getFieldValue(element, column);
        switch (column.type) {
            case 'TYPE':
                // type ouvrage
                if (!value) {
                    return '';
                }
                return value.nom;
            case 'PARENT':
                // parent
                // -> on cherche dans parents
                if (element.parents && element.parents.length) {
                    const parent = element.parents.find(p => p.type == column.property);
                    if (parent) {
                        return parent.nom;
                    }
                }
                // -> si l'élément est du type demandé dans les parents, alors c'est le nom de l'élément qu'il faut renvoyer
                if (element.typeElement == column.property) {
                    return element.nom;
                }
                return '';
            case 'SURFACE':
                // surface
                if (value == null) {
                    return '';
                }
                try {
                    return this.numberPipe.transform(value, '.2-2') + ' m²';
                }
                catch (e) {
                }
                return '';
            case 'DATETIME':
                // date
                if (value == null) {
                    return '';
                }
                try {
                    return this.datePipe.transform(value, 'medium');
                }
                catch (e) {
                }
                return '';
            case 'DATE':
                // date
                if (value == null) {
                    return '';
                }
                try {
                    return this.datePipe.transform(value, 'mediumDate');
                }
                catch (e) {
                }
                return '';
            case 'BYTES':
                // bytes
                if (value == null) {
                    return '';
                }
                try {
                    return this.byteFormatPipe.transform(value);
                }
                catch (e) {
                }
                return '';
            case 'NOMBRE':
                // type nombre
                if (value == null) {
                    return '';
                }
                const unite = column.parametreNombre ? column.parametreNombre.unite : '';
                const nbDecimalesMin = column.parametreNombre ? (column.parametreNombre.nbDecimales || 0) : 0;
                const nbDecimalesMax = column.parametreNombre ? (column.parametreNombre.nbDecimales || 2) : 2;
                try {
                    return this.numberPipe.transform(value, '.' + nbDecimalesMin + '-' + nbDecimalesMax) + (unite ? ' ' + unite : '');
                }
                catch (e) {
                    return value;
                }
            case 'LOT':
            case 'PIECE':
            case 'OUVRAGE':
                // lot/pièce/ouvrage (pointer)
                if (!value) {
                    return '';
                }
                if (element.parametresPointer[column.codeBim] != null) {
                    return element.parametresPointer[column.codeBim].nom;
                }
                else {
                    return value;
                }
            case 'BOOLEEN':
                const fieldValueAsBoolean = this.getFieldValueAsBoolean(element, column);
                return fieldValueAsBoolean == null ? '' : fieldValueAsBoolean ? 'Oui' : 'Non';
            case 'TYPE_LIEN_USAGE':
                return this.typeLienUsagePipe.transform(value);
            case 'USER':
                let userName = '';
                const user = value;
                if (!!user.firstName) {
                    userName += (user.firstName + " ");
                }
                if (!!user.lastName) {
                    userName += user.lastName;
                }
                if (userName == '') {
                    userName = user.email;
                }
                return userName;
            default:
                // par défaut
                if (!value) {
                    return '';
                }
                return String(value);
        }
    }
    /**
     * Renvoie la valeur booléenne d'un champ.
     * Renvoie vrai ssi booléen true ou valeur textuelle "true", faux ssi booléen false ou valeur textuelle "false", nul sinon.
     */
    getFieldValueAsBoolean(element, column) {
        const booleanValue = this.getFieldValue(element, column);
        if (booleanValue === true || booleanValue === 'true') {
            return true;
        }
        if (booleanValue === false || booleanValue === 'false') {
            return false;
        }
        return null;
    }
    /**
     * Renvoie la valeur textuelle d'un URL (pour l'affichage)
     */
    getFieldValueAsUrl(element, column) {
        const fieldValue = this.getFieldValueAsString(element, column);
        if (fieldValue && fieldValue.indexOf('http://') !== 0 && fieldValue.indexOf('https://') !== 0) {
            return 'http://' + fieldValue;
        }
        return fieldValue;
    }
    /**
     * Renvoie le type d'input à associer en fonction du type de colonne
     */
    getInputTypeFromColumnType(columnType) {
        let type;
        switch (columnType) {
            case 'NOMBRE':
            case 'SURFACE':
                type = 'number';
                break;
            case 'DATE':
            case 'DATETIME':
                type = 'date';
                break;
            case 'URL':
                type = 'url';
                break;
            default:
                type = 'text';
                break;
        }
        return type;
    }
    /**
     * Renvoie le step d'un input numérique en fonction de la définition d'un paramètre
     */
    getStepFromParameterNombre(param) {
        return param.nbDecimales ? 1 / Math.pow(10, param.nbDecimales) : 1;
    }
    /**
     * Renvoie l'alignement CSS voulu pour une colonne
     */
    getAlignClass(column) {
        switch (column.type) {
            // Tout est aligné à gauche, sauf les nombres (et surfaces) qui sont alignés à droite
            case 'SURFACE':
            case 'NOMBRE':
                return 'mat-cell-align-right';
            default:
                return ''; // alignement gauche par défaut (pas de classe particulière)
        }
    }
}
TableService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TableService_Factory() { return new TableService(i0.ɵɵinject(i1.DecimalPipe), i0.ɵɵinject(i1.DatePipe), i0.ɵɵinject(i2.BytesPipe), i0.ɵɵinject(i3.TypeLienUsagePipe)); }, token: TableService, providedIn: "root" });
